const {
    fileTypeEnum, languageEnum, userStatusEnum, administrationRoleEnum,
    trainingAndFieldRoleEnum,
    permissionsEnum,
    contentCreatingRoleEnum, sitePrepUserTypeEnum, procedureTypeEnum, legacyPermissionsEnum, frontlinePermissionEnum,
    SurveyTypeEnum,
} = require('./sharedEnums');

const imageExtensions = ['png', 'jpg', 'jpeg', 'gif'];
const videoExtensions = ['mp4', 'm4a', 'm4v', 'f4v', 'f4a', 'm4b', 'm4r', 'f4b', 'mov', '3gp', '3gp2', '3g2', '3gpp', '3gpp2', 'ogg', 'oga', 'ogv', 'ogx', 'wmv', 'wma', 'asf', 'webm', 'flv', 'avi', 'mkv'];
const threeDExtensions = ['fbx', 'obj', 'gltf2', 'stl', 'ply', '3mf', 'gltf', 'glb', 'stp', 'step'];
const legalFastTrackExtensions = ['pxz', '3ds', 'fbx', 'gltf', 'glb', 'igs', 'iges', 'jt', 'stl', 'obj', 'mtl', 'prt', 'x_b', 'x_t', 'p_t', 'p_b', 'xmt', 'xmt_txt', 'xmt_bin', 'pdf', '3dm', 'skp', 'stp', 'step', 'stpz', 'stepz', 'stpx', 'stpxz', '3dxml'];


const frontline3DExtensions = [
    fileTypeEnum.FUSION, fileTypeEnum.FRONTLINE_WEB, fileTypeEnum.FRONTLINE_ANDROID, fileTypeEnum.FRONTLINE_HOLOLENS,
    fileTypeEnum.FRONTLINE_IOS, fileTypeEnum.FRONTLINE_WINDOWS, fileTypeEnum.FRONTLINE_MAC
];

const has3DFileExtension = (file) => [...frontline3DExtensions, ...threeDExtensions].some(e => e.toLowerCase() === (file.name.split('.').pop().toLowerCase()));

function filter3DFilesBeforeUpload(files) {
    const filesArray = Array.from(files);
    let errorMessage = ''
    const notThreeDFiles = filesArray.filter(file => !has3DFileExtension(file));
    const threeDFiles = filesArray.filter(file => has3DFileExtension(file));

    if (notThreeDFiles.length !== filesArray.length) {
        const fileNames = threeDFiles.map(f => f.name).join(', ');
        errorMessage = `Some files couldn’t be added: ${fileNames}`;
    }
    if (notThreeDFiles.length === 0) {
        return {files: null, errorMessage};
    }
    const fileListWithout3D = new DataTransfer();
    notThreeDFiles.forEach(file => {
        fileListWithout3D.items.add(file);
    });
    files = fileListWithout3D.files;
    return {files, errorMessage};
}

const MILLIS_IN_HOUR = 3600 * 1000;
const MILLIS_IN_MINUTE = 60 * 1000;
const MILLIS_IN_SECOND = 1000;

const FAST_TRACK_FILE_LIMIT = 5e+8 + 5e+8 + 5e+8 + 5e+8;// 2GB

function getFileTypeFromExtension(fileExtension) {
    fileExtension = fileExtension.toLowerCase();
    let fileType = fileTypeEnum.OTHER;
    if (imageExtensions.includes(fileExtension)) {
        fileType = fileTypeEnum.IMAGE;
    } else if (videoExtensions.includes(fileExtension)) {
        fileType = fileTypeEnum.VIDEO;
    } else if (fileExtension === fileTypeEnum.PDF) {
        fileType = fileTypeEnum.PDF;
    } else if (threeDExtensions.includes(fileExtension) || legalFastTrackExtensions.includes(fileExtension)) {
        fileType = fileTypeEnum.THREE_D;
    } else if (frontline3DExtensions.includes(fileExtension)) {
        fileType = fileExtension;
    } else if (fileExtension === fileTypeEnum.FRONTLINE_DESIGNER) {
        fileType = fileExtension;
    } else if (fileExtension === fileTypeEnum.UNITY_PACKAGE) {
        fileType = fileTypeEnum.UNITY_PACKAGE;
    } else if (fileExtension === fileTypeEnum.FLDT) {
        fileType = fileTypeEnum.FLDT;
    } else if (fileExtension === fileTypeEnum.ZIP) {
        fileType = fileTypeEnum.ZIP;
    } else if (fileExtension === fileTypeEnum.RAR) {
        fileType = fileTypeEnum.RAR;
    } else if (fileExtension === fileTypeEnum.GUIDE) {
        fileType = fileTypeEnum.GUIDE;
    } else if (fileExtension === fileTypeEnum.DOCX) {
        fileType = fileTypeEnum.DOCX;
    } else if (fileExtension === fileTypeEnum.HTML) {
        fileType = fileTypeEnum.HTML;
    } else if (fileExtension === fileTypeEnum.CSV) {
        fileType = fileTypeEnum.CSV;
    } else if (fileExtension === fileTypeEnum.XLS) {
        fileType = fileTypeEnum.XLS;
    } else if (fileExtension === fileTypeEnum.XLSX) {
        fileType = fileTypeEnum.XLSX;
    } else if (fileExtension === fileTypeEnum.TXT) {
        fileType = fileTypeEnum.TXT;
    } else if (fileExtension === fileTypeEnum.RTF) {
        fileType = fileTypeEnum.RTF;
    } else if (fileExtension === fileTypeEnum.MD) {
        fileType = fileTypeEnum.MD;
    } else if (fileExtension === fileTypeEnum.ODT) {
        fileType = fileTypeEnum.ODT;
    }
    return fileType;
}

const getMultiKey = key => {
    switch (key) {
        case "ConnectionName":
            return "ConnectionNameMulti"
        case "StepHeader":
            return "StepHeaderMulti"
        case "StepText":
            return "StepTextMulti"
        case "ConformationText":
            return "ConfirmationTextMulti"
        case "NodeMediaFilesRefs":
            return "NodeMediaFileRefsMulti"
        case "CustomTextToSpeech":
            return "CustomTextToSpeechMulti"
        case "NodeCode":
            return "NodeCode";
        default:
            return
    }
}

function calculateShortDeviceId(deviceId) {
    if (!deviceId) {
        return "none";
    }
    let newId = "" + (deviceId.charCodeAt(0) % 9 + 1);
    const inputLength = deviceId.length;
    for (let i = 1; i < 9; i++) {
        newId = `${newId}${deviceId.charCodeAt(i % inputLength) % 10}`;
    }

    return newId;
}

/**
 * @deprecated Support for old hololens version please use calculateShortDeviceId
 */
function calculateShortDeviceIdForHololens(deviceId) {
    if (!deviceId) {
        return "none";
    }
    let id = 1;
    for (let l of deviceId) {
        const n = parseInt(l.charCodeAt(0), 10);
        id += n;
    }
    if (id.toString().length < 9) {
        id *= 12345678;
    }
    id = Math.abs(id);

    return id.toString().substring(0, 9);
}

function generateRandom(length, base) {
    let str = '';
    for (let i = 0; i < length; i++) {
        str += base.charAt(Math.floor(Math.random() * base.length));
    }
    return str;
}

function deleteUnpermittedPermissions(domainSettings, permissionsSet) {
    if (domainSettings?.isFlowsAndProceduresOff || domainSettings?.IsFlowsAndProceduresOff) {
        permissionsSet.delete(permissionsEnum.VIEW_PROCEDURE_AND_MEDIA);
    }

    if (domainSettings?.isRemoteSupportOff || domainSettings?.IsRemoteSupportOff) {
        permissionsSet.delete(permissionsEnum.VIEW_REMOTE_SUPPORT);
        permissionsSet.delete(permissionsEnum.VIEW_REMOTE_SUPPORT_DEVICE_ID);
        permissionsSet.delete(permissionsEnum.CREATE_REMOTE_SUPPORT);
        permissionsSet.delete(permissionsEnum.SCHEDULE_REMOTE_SUPPORT);
        permissionsSet.delete(permissionsEnum.CALL_REMOTE_SUPPORT);
        permissionsSet.delete(permissionsEnum.VIEW_REMOTE_SUPPORT_USERS_LIST);
    }

    if (domainSettings?.isVirtualTrainingRoomOff || domainSettings?.IsVirtualTrainingRoomOff) {
        permissionsSet.delete(permissionsEnum.VIEW_VIRTUAL_ROOM);
        permissionsSet.delete(permissionsEnum.CREATE_VIRTUAL_ROOM);
        permissionsSet.delete(permissionsEnum.SCHEDULE_VIRTUAL_ROOM);
    }

    if (domainSettings?.isPartsCatalogOff || domainSettings?.IsPartsCatalogOff) {
        permissionsSet.delete(permissionsEnum.EDIT_CAD_DATA);
        permissionsSet.delete(permissionsEnum.GET_CAD_DATA);
        permissionsSet.delete(permissionsEnum.SUPPORT_PARTS_CATALOG_LIST);
    }

    if (!domainSettings?.IsObjectDetectionEnabled && !domainSettings?.isObjectDetectionEnabled) {
        permissionsSet.delete(permissionsEnum.NEW_OBJECT_TARGET_SYSTEM);
    }

    if (!domainSettings?.IsAppFastTrackEnabled && !domainSettings?.isAppFastTrackEnabled) {
        permissionsSet.delete(permissionsEnum.IN_APP_DIGITAL_TWIN_CREATION);
    }

    if (!domainSettings?.IsQrCodeEnabled && !domainSettings?.isQrCodeEnabled) {
        permissionsSet.delete(permissionsEnum.VIEW_QR_CODE);
    }
    if (!domainSettings?.IsSupportAIChatWebEnabled && !domainSettings?.isSupportAIChatWebEnabled) {
        permissionsSet.delete(permissionsEnum.SUPPORT_AI_CHAT);
    }
    if (!domainSettings?.IsCanImportFromGuides && !domainSettings?.isCanImportFromGuides) {
        permissionsSet.delete(permissionsEnum.UPLOAD_GUIDE_FILE);
    }
    if (!domainSettings?.CanAddAiChatKnowledge) {
        permissionsSet.delete(permissionsEnum.AI_STUDIO)
    }
    if (!domainSettings?.IsSupportAIChatEnabled) {
        permissionsSet.delete(permissionsEnum.AI_GENERATION)
    }
    if (!domainSettings?.IsTranslationAiEnabled){
        permissionsSet.delete(permissionsEnum.AI_TRANSLATION)
    }
    if (!domainSettings?.IsIntegrationEnabled) {
        permissionsSet.delete(permissionsEnum.SUPPORT_INTEGRATION)
    }
    if (domainSettings?.IsLocalCacheSavingDisabled === false){
        permissionsSet.delete(permissionsEnum.DISABLED_LOCAL_CACHE_SAVING)
    }
    if (!domainSettings?.CanRecordingRsCall) {
        permissionsSet.delete(permissionsEnum.RECORD_CALLS);
    }
    if (!domainSettings?.SitePrepEnabled) {
        permissionsSet.delete(permissionsEnum.SITE_PREP);
    }
}

function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

const basePermissions = [
    permissionsEnum.VIEW_THREE_D_SCENES,
    permissionsEnum.VIEW_PROCEDURE_AND_MEDIA,
    permissionsEnum.VIEW_COLLABORATORS,
    permissionsEnum.VIEW_REMOTE_SUPPORT,
    permissionsEnum.VIEW_REMOTE_SUPPORT_DEVICE_ID,
    permissionsEnum.VIEW_REMOTE_SUPPORT_USERS_LIST,
    permissionsEnum.VIEW_VIRTUAL_ROOM,
    permissionsEnum.VIEW_PUBLISHED,
    permissionsEnum.VIEW_RECORDER,
    permissionsEnum.SUPPORT_PARTS_CATALOG_LIST,
    permissionsEnum.NEW_OBJECT_TARGET_SYSTEM,
    permissionsEnum.UPLOAD_MEDIA,
    permissionsEnum.LOCAL_CACHE_SAVING
]
const contentCreatorPermissions = [
    ...basePermissions,
    permissionsEnum.EDIT_PROCEDURES,
    permissionsEnum.PUBLISH_PROCEDURE,
    permissionsEnum.MOVE_AND_DELETE_ITEMS,
    permissionsEnum.DUPLICATE_PROCEDURE,
    permissionsEnum.CREATE_PROCEDURE_AND_SETTINGS,
    permissionsEnum.PROJECT_SETTINGS,
    permissionsEnum.VIEW_UNPUBLISHED,
    permissionsEnum.DUPLICATE_PROJECT,
    permissionsEnum.EDIT_ROLES,
    permissionsEnum.ACCESS_MEDIA,
    permissionsEnum.SUPPORT_BOOKMARKS_CONTEXT_MENU_OPTIONS,
    permissionsEnum.EDIT_THREE_D_MODES,
    permissionsEnum.GET_SPARE_PARTS_DATA,
    permissionsEnum.GET_CAD_DATA,
    permissionsEnum.IN_APP_DIGITAL_TWIN_CREATION,
    permissionsEnum.UPLOAD_GUIDE_FILE,
    permissionsEnum.AI_TRANSLATION,
    permissionsEnum.AI_GENERATION,
    permissionsEnum.SHARE_ITEM,
    permissionsEnum.SUPPORT_AI_CHAT,
    permissionsEnum.SITE_PREP,
]
const rolesPermissions = {
    [trainingAndFieldRoleEnum.OPERATOR]:
        [
            ...basePermissions,
            permissionsEnum.IN_APP_DIGITAL_TWIN_CREATION,
            permissionsEnum.SUPPORT_AI_CHAT,
        ],
    [trainingAndFieldRoleEnum.OPERATOR_3D]:
        [
            ...basePermissions,
            permissionsEnum.IN_APP_DIGITAL_TWIN_CREATION,
            permissionsEnum.CREATE_REMOTE_SUPPORT,
            permissionsEnum.CALL_REMOTE_SUPPORT,
            permissionsEnum.SUPPORT_AI_CHAT,
        ],
    [trainingAndFieldRoleEnum.FIELD_SERVICE_ENGINEER]:
        [
            ...basePermissions,
            permissionsEnum.GET_SPARE_PARTS_DATA,
            permissionsEnum.IN_APP_DIGITAL_TWIN_CREATION,
            permissionsEnum.CREATE_REMOTE_SUPPORT,
            permissionsEnum.CALL_REMOTE_SUPPORT,
            permissionsEnum.SUPPORT_AI_CHAT,
        ],
    [trainingAndFieldRoleEnum.SERVICE_SUPPORT_EXPERT]:
        [
            ...basePermissions,
            permissionsEnum.ANALYTICS_TAB,
            permissionsEnum.PROJECT_DASHBOARD,
            permissionsEnum.CREATE_REMOTE_SUPPORT,
            permissionsEnum.CALL_REMOTE_SUPPORT,
            permissionsEnum.SCHEDULE_REMOTE_SUPPORT,
            permissionsEnum.CREATE_VIRTUAL_ROOM,
            permissionsEnum.SCHEDULE_VIRTUAL_ROOM,
            permissionsEnum.GET_SPARE_PARTS_DATA,
            permissionsEnum.IN_APP_DIGITAL_TWIN_CREATION,
            permissionsEnum.RECORD_CALLS,
            permissionsEnum.SUPPORT_AI_CHAT,
        ],
    [trainingAndFieldRoleEnum.INSTRUCTOR]:
        [
            ...basePermissions,
            permissionsEnum.SUPPORT_BOOKMARKS_CONTEXT_MENU_OPTIONS,
            permissionsEnum.ANALYTICS_TAB,
            permissionsEnum.PROJECT_DASHBOARD,
            permissionsEnum.EDIT_COLLABORATORS,
            permissionsEnum.CREATE_REMOTE_SUPPORT,
            permissionsEnum.CALL_REMOTE_SUPPORT,
            permissionsEnum.SCHEDULE_REMOTE_SUPPORT,
            permissionsEnum.CREATE_VIRTUAL_ROOM,
            permissionsEnum.SCHEDULE_VIRTUAL_ROOM,
            permissionsEnum.GET_SPARE_PARTS_DATA,
            permissionsEnum.IN_APP_DIGITAL_TWIN_CREATION,
            permissionsEnum.SUPPORT_AI_CHAT,
        ],
    [trainingAndFieldRoleEnum.SERVICE_SUPPORT_MANAGER]:
        [
            ...basePermissions,
            permissionsEnum.ANALYTICS_TAB,
            permissionsEnum.PROJECT_DASHBOARD,
            permissionsEnum.EDIT_COLLABORATORS,
            permissionsEnum.CREATE_REMOTE_SUPPORT,
            permissionsEnum.CALL_REMOTE_SUPPORT,
            permissionsEnum.SCHEDULE_REMOTE_SUPPORT,
            permissionsEnum.CREATE_VIRTUAL_ROOM,
            permissionsEnum.SCHEDULE_VIRTUAL_ROOM,
            permissionsEnum.GET_SPARE_PARTS_DATA,
            permissionsEnum.IN_APP_DIGITAL_TWIN_CREATION,
            permissionsEnum.RECORD_CALLS,
            permissionsEnum.SUPPORT_AI_CHAT,
        ],
    [contentCreatingRoleEnum.CONTENT_CREATOR]: contentCreatorPermissions,
    [contentCreatingRoleEnum.ADVANCED_CONTENT_CREATOR]:
        [
            ...contentCreatorPermissions,
            permissionsEnum.EDIT_CAD_DATA,
            permissionsEnum.UPDATE_DOMAIN_MATERIALS,
        ],
    [administrationRoleEnum.USAGE_ANALYSIS]:
        [
            ...basePermissions,
            permissionsEnum.PROJECT_DASHBOARD,
            permissionsEnum.ANALYTICS_TAB,
            permissionsEnum.GENERATE_ANALYTICS_REPORTS,
            permissionsEnum.IN_APP_DIGITAL_TWIN_CREATION,
            permissionsEnum.SUPPORT_AI_CHAT,
        ],
    [administrationRoleEnum.WORKSPACE_ADMIN]:
        [
            ...basePermissions,
            permissionsEnum.PROJECT_DASHBOARD,
            permissionsEnum.ANALYTICS_TAB,
            permissionsEnum.GET_CAD_DATA,
            permissionsEnum.CREATE_VIRTUAL_ROOM,
            permissionsEnum.EDIT_COLLABORATORS,
            permissionsEnum.GENERATE_ANALYTICS_REPORTS,
            permissionsEnum.CREATE_PROCEDURE_AND_SETTINGS,
            permissionsEnum.SUPPORT_BOOKMARKS_CONTEXT_MENU_OPTIONS,
            permissionsEnum.IN_APP_DIGITAL_TWIN_CREATION,
            permissionsEnum.PROJECT_SETTINGS,
            permissionsEnum.UPLOAD_GUIDE_FILE,
            permissionsEnum.AI_STUDIO,
            permissionsEnum.SUPPORT_INTEGRATION,
            permissionsEnum.UPDATE_DOMAIN_MATERIALS,
            permissionsEnum.SUPPORT_AI_CHAT,
        ]
}

function checkWorkspacePermission(userWorkspaceDetails, permissionKey, domainSettings) {
    if (!permissionKey) {
        return true;
    }
    return checkWorkspacePermissions(userWorkspaceDetails, [permissionKey], domainSettings).pop();
}

function checkWorkspacePermissions(userWorkspaceDetails, permissionKeysArray, domainSettings) {
    if (!userWorkspaceDetails) {
        console.error('checkAllowed: missing userWorkspaceDetails');
        return permissionKeysArray.map(() => false);
    }
    if (userWorkspaceDetails.IsWorkspaceOwner) {
        const permissionKeysSet = new Set();
        for (let key in permissionsEnum) {
            permissionKeysSet.add(permissionsEnum[key]);
        }
        if (domainSettings) {
            deleteUnpermittedPermissions(domainSettings, permissionKeysSet);
        }
        const permissionsArray = [];
        permissionKeysArray.forEach(permissionKey => {
            permissionsArray.push(permissionKeysSet.has(permissionKey))
        })
        return permissionsArray;
    }
    if (!userWorkspaceDetails.Roles) {
        return permissionKeysArray.map(() => false);
    }
    if (!permissionKeysArray) {
        return permissionKeysArray.map(() => true);
    }
    let permissionsSet = new Set();
    const addToPermission = permission => {
        try {
            permissionsSet.add(permission)
        } catch (e) {// just don't add twice
        }
    }


    const adminPermissions = rolesPermissions[userWorkspaceDetails.Roles.AdministrationRole] || {};
    const contentPermissions = rolesPermissions[userWorkspaceDetails.Roles.ContentCreationRole] || {};
    const trainingPermissions = rolesPermissions[userWorkspaceDetails.Roles.TrainingAndFieldRole] || {};
    Object.values(contentPermissions).forEach(addToPermission);
    Object.values(adminPermissions).forEach(addToPermission);
    Object.values(trainingPermissions).forEach(addToPermission);

    if (permissionsSet.size === 0)
        permissionsSet = new Set(basePermissions)

    deleteUnpermittedPermissions(domainSettings, permissionsSet);
    const permissionsArray = [];
    permissionKeysArray.forEach(permissionKey => {
        permissionsArray.push(permissionsSet.has(permissionKey))
    })

    return permissionsArray;
}

module.exports = {
    escapeRegExp,
    deleteUnpermittedPermissions,
    calculateShortDeviceIdForHololens,
    calculateShortDeviceId,
    filter3DFilesBeforeUpload,
    getLastLoginDate: (user) => {
        if (!user) {
            return null;
        }
        return user.LastAppOpenDate || user.LastLoginDate || user.LastLoginDateTime || user.LastLoginDateLegacy;
    },
    getTextFromLanguageKey(key) {
        const camelCase = key.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
        return this.strToCapital(camelCase);
    },
    generateRandomStringOfNumbers(length) {
        const base = '123456789';
        return generateRandom(length, base);
    },
    generateRandomString(length) {
        const base = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        return generateRandom(length, base);
    },
    strToCapitalAll(str) {
        if (!str || typeof str !== 'string') {
            return '';
        }
        return str.split(' ').map(substr => this.strToCapital(substr)).join(' ');
    },
    strToCapital(str) {
        if (!str || typeof str !== 'string') {
            return '';
        }
        if (str.length === 1) {
            str[0].toUpperCase();
        }

        return str[0].toUpperCase() + str.substr(1).toLowerCase();
    },
    threeDExtensions,
    getFileTypeFromExtension,
    getTypeFromFileName(fileName) {
        const fileInfo = fileName.split(".");
        const fileExtension = fileInfo.pop();

        return getFileTypeFromExtension(fileExtension);
    },
    fusionTypes: [
        fileTypeEnum.FUSION,
        fileTypeEnum.FRONTLINE_WEB,
        fileTypeEnum.FRONTLINE_ANDROID,
        fileTypeEnum.FRONTLINE_HOLOLENS,
        fileTypeEnum.FRONTLINE_IOS,
        fileTypeEnum.FRONTLINE_WINDOWS,
        fileTypeEnum.FRONTLINE_MAC
    ],

    isUserAdmin(db, user) {
        if (!user || typeof user !== 'object' || user.Status === userStatusEnum.DELETED || !user.Domains || !user.Domains[db] || !user.Domains[db].Roles) {
            return false;
        }
        const isAdmin = user.Domains[db].Roles.AdministrationRole === administrationRoleEnum.WORKSPACE_ADMIN;
        const isOwner = user.Domains[db].IsWorkspaceOwner;
        return isAdmin || isOwner;
    },
    getIllegalDomainMessage(domain) { // TODO translate
        if (!domain) {
            return 'Workspace name cannot be empty';
        }
        if (/[^A-Za-z]+/g.test(domain[0])) {
            return 'Workspace must start with a letter'
        }
        if (/[^A-Za-z0-9-]+/g.test(domain)) {
            return 'Workspace can only contain numbers, letters and "-"'
        }
        if (domain.length < 3) {
            return 'Workspace name  must be of minimum length of 3 characters';
        }
        if (domain.length >= 38) {
            return 'Workspace name  must be of maximum length of 38 characters';
        }
        return null;
    },
    getPermissionSet(userWorkspaceDetails, domainSettings, user, isForWebGL = false) {
        if (!userWorkspaceDetails) {
            console.error('checkAllowed: missing userWorkspaceDetails');
            return isForWebGL ? [] : {
                permissions: [],
                legacyPermissions: []
            };
        }
        const permissions = new Set();
        if (user?.IsFrontlineContentCreatorUser) {
            permissions.add(frontlinePermissionEnum.FRONTLINE_CONTENT_CREATOR)
        }
        if (userWorkspaceDetails.IsWorkspaceOwner) {
            const legacyPermissionSet = new Set();
            for (let key in permissionsEnum) {
                if (isForWebGL) {
                    if (!key.includes('VIRTUAL'))
                        permissions.add(permissionsEnum[key]);
                } else
                    permissions.add(permissionsEnum[key]);
            }
            deleteUnpermittedPermissions(domainSettings, permissions);

            for (let key in legacyPermissionsEnum) {
                if (permissions.has(legacyPermissionsEnum[key])) {
                    legacyPermissionSet.add(legacyPermissionsEnum[key]);
                }
            }
            return isForWebGL ? [...permissions] : {
                permissions: [...permissions],
                legacyPermissions: [...legacyPermissionSet]
            };
        }
        if (!userWorkspaceDetails.Roles) {
            return isForWebGL ? [] : {
                permissions: [],
                legacyPermissions: []
            };
        }

        const addToPermission = permission => {
            try {
                if (isForWebGL) {
                    if (!permission.includes('virtual'))
                        permissions.add(permission);
                } else {
                    permissions.add(permission);
                }
            } catch (e) {// just don't add twice
            }
        }

        const adminPermissions = module.exports.rolesPermissions[userWorkspaceDetails.Roles.AdministrationRole] || {};
        Object.values(adminPermissions).forEach(addToPermission);
        const contentPermissions = module.exports.rolesPermissions[userWorkspaceDetails.Roles.ContentCreationRole] || {};
        Object.values(contentPermissions).forEach(addToPermission);
        const trainingPermissions = module.exports.rolesPermissions[userWorkspaceDetails.Roles.TrainingAndFieldRole] || {};
        Object.values(trainingPermissions).forEach(addToPermission);

        deleteUnpermittedPermissions(domainSettings, permissions);

        const legacyPermissionSet = new Set();

        for (let key in legacyPermissionsEnum) {
            if (permissions.has(legacyPermissionsEnum[key])) {
                legacyPermissionSet.add(legacyPermissionsEnum[key]);
            }
        }

        return isForWebGL ? [...permissions] : {
            isWorkspaceOwner: false,
            permissions: [...permissions],
            legacyPermissions: [...legacyPermissionSet]
        };
    },
    checkWorkspacePermission,
    checkWorkspacePermissions,
    isLegalPassword(password) {
        return (
            password.length >= 8 &&
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*(),.?":{}|<>])/.test(password)
        );
    },
    testArraysHaveSameContent(arr1, arr2) {
        const testSet1 = new Set(arr1);
        const testSet2 = new Set(arr2)
        testSet2.forEach(item => {
            if (testSet1.has(item)) {
                testSet1.delete(item)
            } else return false
        })
        return testSet1.size === 0
    },

    getNextVersion(versionsList) {
        if (!versionsList || !versionsList.length) {
            return '1.0';
        }
        let maxVersionParts = [0, 1];

        for (const version of versionsList) {
            if (!version) {
                continue;
            }
            const versionParts = version.split('.');
            let isLarger = false;
            for (let i = 0; i < versionParts.length; i++) {
                const part = parseInt(versionParts[i]);
                const currentMaxPart = maxVersionParts[i] || 0;
                if (part > currentMaxPart) {
                    isLarger = true;
                    break;
                }
                if (part < currentMaxPart) {
                    break;
                }
                if (part === currentMaxPart) {
                    // noinspection UnnecessaryContinueJS
                    continue;
                }
            }

            if (isLarger) {
                maxVersionParts = versionParts;
            }
        }

        for (let i = maxVersionParts.length - 1; i >= 0; i--) {
            if (maxVersionParts[i] < 99) {
                maxVersionParts[i]++;
                break;
            } else {
                maxVersionParts[i] = 0;
            }
        }
        return maxVersionParts.join('.');
    },
    getUserFullName(user, capital = false) {
        if (!user) {
            return ""
        }
        let firstName = user.Name;
        let lastName = user.LastName;
        if (capital) {
            firstName = module.exports.strToCapital(firstName);
            lastName = module.exports.strToCapital(lastName);
        }
        let fullName = "";
        fullName += firstName || "";
        fullName += !!firstName && !!lastName ? " " : "";
        fullName += lastName || "";
        return fullName;
    },
    getGuestFullName(guest, capital = false) {
        if (!guest) {
            return ""
        }
        let name = guest.GuestName;
        if (capital) {
            name = module.exports.strToCapital(name);
        }
        return name;
    },
    getMultiKey,
    getProcedureText(procedureObj, key, procedure) {
        const multiKey = getMultiKey(key);
        const selectedLanguage = procedure?.selectedLanguage || procedure?.DefaultLanguage || languageEnum.ENGLISH_US;
        if (procedureObj?.[multiKey]?.[selectedLanguage] !== "" && !procedureObj?.[multiKey]?.[selectedLanguage]) {
            return procedureObj?.[key] || "";
        } else return procedureObj[multiKey][selectedLanguage];
    },
    editProcedureText(updatedText, procedureObj, key, procedure) {
        const multiKey = getMultiKey(key);
        const noOriginalKey = ["CustomTextToSpeech"].includes(key);
        if (!procedure) {
            if (noOriginalKey) {
                procedureObj[multiKey][languageEnum.ENGLISH_US] = updatedText;
            } else procedureObj[key] = updatedText;
            return procedureObj;
        }

        const selectedLanguage = procedure?.selectedLanguage || procedure?.DefaultLanguage || languageEnum.ENGLISH_US;

        if (!procedureObj[multiKey]) {
            procedureObj[multiKey] = {[selectedLanguage]: updatedText};
        } else procedureObj[multiKey][selectedLanguage] = updatedText;

        if (!noOriginalKey && (!procedure?.DefaultLanguage || selectedLanguage === procedure.DefaultLanguage)) {     //for backwards compatability, so older versions of the pc app can read procedures edited with the new editor
            procedureObj[key] = updatedText
        }

        return procedureObj
    },
    getNodeMedia(nodeObj, key, procedure, getOriginal = false) {
        const multiKey = getMultiKey(key);
        const selectedLanguage = procedure?.selectedLanguage || procedure?.DefaultLanguage || languageEnum.ENGLISH_US;
        const hasMultiLangOptionInSelectedLanguage = !!nodeObj?.[multiKey]?.[selectedLanguage];
        const getAnyAndOptionInSelectedLanguageHasNoOverride = !getOriginal && !nodeObj?.[multiKey]?.[selectedLanguage]?.IsOverrideActive;
        if (!hasMultiLangOptionInSelectedLanguage) {
            const getAnyAndHasOptionInDefaultLanguageOrEnglish = !getOriginal && !!nodeObj?.[multiKey]?.[procedure?.DefaultLanguage || languageEnum.ENGLISH_US];
            return {
                HasReceivedFirstEdits: false,
                IsOverrideActive: false,
                FileRefs: getAnyAndHasOptionInDefaultLanguageOrEnglish
                    ? nodeObj[multiKey][procedure?.DefaultLanguage || languageEnum.ENGLISH_US].FileRefs || []
                    : getOriginal ? [] : nodeObj?.[key] || []
            }
        } else if (getAnyAndOptionInSelectedLanguageHasNoOverride) {
            return {
                HasReceivedFirstEdits: !!nodeObj[multiKey][selectedLanguage].HasReceivedFirstEdits,
                IsOverrideActive: nodeObj[multiKey][selectedLanguage].IsOverrideActive,
                FileRefs: nodeObj?.[multiKey]?.[procedure?.DefaultLanguage || languageEnum.ENGLISH_US]?.FileRefs || []
            };
        } else return nodeObj[multiKey][selectedLanguage];
    },
    editNodeMedia(updatedArr, isOverrideActive, nodeObj, key, procedure) {
        if (!procedure) {
            nodeObj[key] = updatedArr;
            return nodeObj;
        }

        const multiKey = getMultiKey(key);
        const selectedLanguage = procedure?.selectedLanguage || procedure?.DefaultLanguage || languageEnum.ENGLISH_US;

        if (!nodeObj[multiKey]) {
            nodeObj[multiKey] = {
                [selectedLanguage]: {
                    HasReceivedFirstEdits: true,
                    IsOverrideActive: !!isOverrideActive,
                    FileRefs: updatedArr
                }
            };
        } else nodeObj[multiKey][selectedLanguage] = {
            HasReceivedFirstEdits: true,
            IsOverrideActive: !!isOverrideActive,
            FileRefs: updatedArr
        };

        if (!procedure?.DefaultLanguage || selectedLanguage === procedure.DefaultLanguage) {     //for backwards compatability, so older versions of the pc app can read procedures edited with the new editor
            nodeObj[key] = updatedArr
        }

        return nodeObj
    },
    getSessionDurationMillis(session) {
        let totalPauseMillis = 0;
        if (!!session.PauseInstances && session.PauseInstances.length > 0) {
            session.PauseInstances.forEach(pause => {
                let pauseMillis = 0;
                if (pause.PauseEnd) {
                    pauseMillis = new Date(pause.PauseEnd).valueOf() - new Date(pause.PauseStart).valueOf()
                }
                totalPauseMillis = totalPauseMillis + pauseMillis;
            })
        }
        const durationMillis = Math.floor(new Date(session.EndTimeStamp).valueOf() - new Date(session.StartTimeStamp).valueOf());
        return durationMillis - totalPauseMillis
    },
    renderDisplayTime(millis) {
        if (millis < 0) {
            return 'N/A';
        }
        const hoursGone = Math.floor(millis / MILLIS_IN_HOUR);
        const onlyMinutes = millis % MILLIS_IN_HOUR;
        const minutesGone = Math.floor(onlyMinutes / MILLIS_IN_MINUTE);
        const onlySeconds = millis % MILLIS_IN_MINUTE;
        const secondsGone = Math.floor(onlySeconds / MILLIS_IN_SECOND);

        let durationStr = '';
        durationStr += hoursGone < 10 ? '0' : '';
        durationStr += `${hoursGone}:`;
        durationStr += minutesGone < 10 ? '0' : '';
        durationStr += `${minutesGone}:`;
        durationStr += secondsGone < 10 ? '0' : '';
        durationStr += `${secondsGone}`;
        return durationStr;
    },
    getSitePrepAssigneeRole(db, user, procedure) {
        let role;
        if (module.exports.isUserAdmin(db, user)) {
            role = sitePrepUserTypeEnum.EDITOR;
        } else procedure.SitePrepAssignees?.forEach(assignee => {
            const userId = typeof user === 'string' ? user : user._id.toString();
            const assigneeObjectId = assignee.UserRef._id || assignee.UserRef;
            if (assigneeObjectId.toString() === userId) {
                role = assignee.UserType;
            }
        });
        return role
    },
    canEditSitePrep(db, user, procedure) {
        if (procedure.ProcedureType !== procedureTypeEnum.SITE_PREP) {
            return false
        }
        const sitePrepRole = module.exports.getSitePrepAssigneeRole(db, user, procedure);
        return !!sitePrepRole && sitePrepRole === sitePrepUserTypeEnum.EDITOR;
    },
    isValidUuidFormat(str) {
        const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
        return regexExp.test(str);
    }, stripKnownHTMLTags(html) {
        const knownTags = [
            "h1", "h2", "h3", "h4", "h5", "h6",
            "div", "span", "p", "a", "ul", "ol", "li",
            "strong", "em", "b", "i", "br", "hr",
            "header", "footer", "nav", "section", "article",
            "table", "thead", "tbody", "tr", "td", "th",
            "img", "form", "input", "button", "label", "select", "option"
        ];

        const regex = new RegExp(
            `</?(${knownTags.join("|")})(\\s[^>]*)?>`,
            "gi"
        );

        return html.replace(regex, "");
    },
    getWorkspacePrettyName(workspaceJson) {
        if (!workspaceJson) {
            console.error('getWorkspacePrettyName missing workspaceJson');
            return '';
        }
        return workspaceJson.WorkspaceDisplayedName || workspaceJson.DomainName
    },
    getWorkspaceStageState(workspace) {
        const isDev = workspace.includes('-dev');
        const isTest = workspace.includes('-test');
        const isBackup = workspace.includes('-backup');
        return {isBackup, isTest, isDev}
    },
    formatDuration(milliseconds) {
        if (!milliseconds || milliseconds <= 0) return "00:00:00";

        let seconds = Math.floor(milliseconds / 1000);

        const hours = Math.floor(seconds / 3600);
        seconds = seconds % 3600;
        const minutes = Math.floor(seconds / 60);
        seconds = seconds % 60;

        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    },
    formatDate(dateString, separator, addDotAfterMonth) {
        const date = new Date(dateString);
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        return `${months[date.getMonth()]}${separator ?? (addDotAfterMonth ? '. ' : ' ')}${date.getDate().toString().padStart(2, '0')}${separator ?? ', '}${date.getFullYear()}`;
    },
    formatDateCaps(dateString) {
        const date = new Date(dateString);
        const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

        return `${months[date.getMonth()]} ${date.getDate().toString().padStart(2, '0')}, ${date.getFullYear()}`;
    },
    getUserRoleForAnalytics(user, workspace) {
        if (!user) return 'Guest';

        const domainInfo = user.Domains?.[workspace];
        if (!domainInfo) return 'N/A';

        if (domainInfo.IsWorkspaceOwner) {
            return 'Workspace Owner';
        }

        return module.exports.addSpacesToTrainingAndFieldRole(domainInfo.Roles?.TrainingAndFieldRole) || 'N/A';
    },
    addSpacesToTrainingAndFieldRole(role) {
        if (!role) return 'N/A';
        return role.replace(/([A-Z])/g, ' $1').trim().replace(/^\w/, (c) => c.toUpperCase());
    },
    deviceType(deviceName) {
        switch (deviceName) {
            case 'HoloLens':
                return 'AR device';
            case 'Windows':
            case 'Mac':
                return 'Desktop';
            case 'Android':
            case 'iOS':
                return 'Handheld';
            default:
                return deviceName;
        }
    },

    LOGIN_DOMAIN: 'login',
    HP_LOGIN_DOMAIN: 'hp-login',
    FAST_TRACK_DOMAIN: 'fast-track',
    FAST_TRACK_VERIFY_DOMAIN: 'fast-track-verify',
    SIGNAL_DOMAIN: 'signal',
    WEBSOCKET_DOMAIN: 'websocket',
    HELPDESK_DOMAIN: 'helpdesk',
    API_DOMAIN: 'api',
    HP_API_DOMAIN: 'hp-api',
    CONVENTION_LOGIN_DOMAIN: 'rotax-login',
    DEVICE_LOGIN_DOMAIN: 'device-login',
    HP_DEVICE_LOGIN_DOMAIN: 'hp-device-login',
    EMBED_DOMAIN: 'embed',
    SESSION_FIELDS_TO_POPULATE_STR:
        'MediaProcedureFile ' +
        'ThreeDFilesAndroid ' +
        'ThreeDFilesHololens ' +
        'ThreeDFilesIOs ' +
        'ThreeDFilesWebgl ' +
        'ThreeDFilesWin ' +
        'ThreeDFilesOsx ' +
        'FLDT ' +
        'SessionRecordedMediaFile ' +
        'SessionMedia.File ' +
        'DebrifNodeEntries.RecordedMediaFile ' +
        'DebrifNodeEntries.NodeRef.NodeMediaFilesRefs',

    SESSION_FIELDS_TO_POPULATE_NODE_MEDIA_OBJ: {
        path: Object.values(languageEnum).map(lang => `DebrifNodeEntries.NodeRef.NodeMediaFileRefsMulti.${lang}.FileRefs`).join(' '),
        model: 'FileSchema'
    },

    THREE_D_FIELDS_TO_POPULATE_STR:
        'MediaProcedureFile ' +
        'ThreeDFilesAndroid ' +
        'ThreeDFilesHololens ' +
        'ThreeDFilesIOs ' +
        'ThreeDFilesWebgl ' +
        'ThreeDFilesWin ' +
        'ThreeDFilesOsx ' +
        'FLDT'
    ,

    UNITY_PACKAGE_STR:
        'UnityPackage',

    THREE_D_FIELDS_TO_POPULATE_STR_NO_MEDIA:
        'ThreeDFilesAndroid ' +
        'ThreeDFilesHololens ' +
        'ThreeDFilesIOs ' +
        'ThreeDFilesWebgl ' +
        'ThreeDFilesWin ' +
        'ThreeDFilesOsx ' +
        'FLDT',

    NODE_MEDIA_MULTI_POPULATE_OBJ: {
        path: Object.values(languageEnum).map(lang => `NestedNodes.NodeMediaFileRefsMulti.${lang}.FileRefs`).join(' '),
        model: 'FileSchema'
    },

    FLOW_USER_POPULATE_OBJ: {
        path: 'FlowEditorUsers',
        select: 'Name LastName Email UserIcon AvatarBackground'
    },

    EDIT_USER_POPULATE_OBJ: {
        path: 'EditLockUser',
        select: 'Name LastName Email UserIcon AvatarBackground'
    },

    LAST_UPDATE_USER_POPULATE_OBJ: {
        path: 'LastUpdateBy',
        select: 'Name LastName Email UserIcon AvatarBackground'
    },

    EDIT_AND_LAST_UPDATE_USER_POPULATE_OBJ: {
        path: 'EditLockUser LastUpdateBy',
        select: 'Name LastName Email UserIcon AvatarBackground'
    },
    basePermissions,
    rolesPermissions,
    MAX_PAGE_SIZE: 200,
    HP_EMPLOYEE_LOGOUT_URL: '/idp/startSLO.ping',
    MAX_PROCEDURE_EDITORS: 4,
    SUPPORT_ROOM_MAX_PARTICIPANTS: 30,
    FAST_TRACK_FILE_LIMIT,
    FAST_TRACK_FILE_LIMIT_MB: FAST_TRACK_FILE_LIMIT / 1e6,
    ALLOW_ONLY_ONE_SURVEY_PER_IDENTIFIER: [
        SurveyTypeEnum.REMOTE_SUPPORT_POST_CALL
    ]
}
